import { stringify } from 'querystring';
import type { WorkflowCapabilities } from '@jira/project-settings__workflow-types/src/workflowTypes.types.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';

type CloudId = string;
type IssueTypeId = string;
type ProjectId = string;

const getApiPrefix = () => 'gateway/api/jira/project-configuration';

export type Params =
	| {
			workflowId: string;
	  }
	| {
			projectId: ProjectId;
			issueTypeId: IssueTypeId;
	  };

export const constructEndpoint = (cloudId: CloudId, params: Params) =>
	`/${getApiPrefix()}/query/${cloudId}/workflow/capabilities?${stringify(params)}`;

export const getWorkflowCapabilities = (
	cloudId: CloudId,
	options: Params,
): Promise<WorkflowCapabilities> =>
	fetchJson(constructEndpoint(cloudId, options), {
		method: 'GET',
	}).catch((e) => {
		log.safeErrorWithoutCustomerData('getWorkflowAvailableCapabilities', e);
		throw e;
	});
